import type { User } from '../types'
import { can } from '../utils/permissions'
import { canAccessPath } from '../components/navigation'

/**
 * Výchozí úvodní stránka, když role žádnou nemá nastavenou (`permissionsStore.homePage === null`):
 * plánovač → Plánování, ostatní → Moje hodiny. Obě cesty jsou pro danou roli vždy dostupné,
 * takže z nich nevznikne smyčka přesměrování.
 */
export function fallbackHomePage(user: User | null | undefined): string {
  return can(user, 'attendance.planning') ? '/attendance/manage' : '/attendance'
}

/**
 * Úvodní stránka uživatele: nastavená pro roli (`homePage` z permissionsStore), pokud na ni uživatel
 * smí — jinak výchozí podle {@link fallbackHomePage}.
 */
export function resolveHomePage(user: User | null | undefined, homePage: string | null): string {
  if (homePage && homePage !== '/' && canAccessPath(user, homePage)) return homePage
  return fallbackHomePage(user)
}
